import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import './theme/globals.css'
import './i18n'
import { bootClockFromUrl } from './lib/clock'
import { installAudioAutoUnlock } from './lib/soundManager'

bootClockFromUrl()
installAudioAutoUnlock()

if (new URLSearchParams(window.location.search).get('kiosk') === '1') {
  document.body.dataset.kiosk = '1'
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
